import {
  ApiResponse,
  CashDiscountGrouped,
  CreateDiscount,
  TokenData,
  CashDiscount,
  OtpResponse,
  CreateDiscountLimits,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class CashDiscountService extends ApiService {
  public async loadCashDiscountType() {
    const url = `${this.apiDomain}/api/discount/cash`;

    const resposne = await http.get<ApiResponse<CashDiscountGrouped>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createDiscount(data: CreateDiscount) {
    const url = `${this.apiDomain}/api/discount/cash`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async updateDiscount(id: string, data: CreateDiscount) {
    const url = `${this.apiDomain}/api/discount/cash/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async getCashDiscount(id: string) {
    const url = `${this.apiDomain}/api/discount/cash/${id}`;

    const resposne = await http.get<ApiResponse<CashDiscount>>(url, this.store);
    return resposne?.data?.data;
  }

  public async requestOtp(purpose?: string, requestType?: string) {
    const url = `${this.apiDomain}/api/otp/request`;

    const response = await http.post<ApiResponse<OtpResponse>>(
      url,
      {
        purpose: purpose || 'Confirm Discount Request',
        requestType,
      },
      this.store
    );
    return response.data;
  }
  public async reSendOtp(id?: string, purpose?: string, requestType?: string) {
    const url = `${this.apiDomain}/api/otp/${id}/resend`;

    const response = await http.put<ApiResponse<OtpResponse>>(
      url,
      {
        purpose: purpose || 'Confirm Discount Request',
        requestType,
      },
      this.store
    );
    return response.data;
  }

  public async updateCashDiscountLimits(
    data?: CreateDiscountLimits,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/discount/cash/${id}/limits`;

    const response = await http.put<ApiResponse<OtpResponse>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async cloneDiscount(data: CreateDiscount, id?: string) {
    const url = `${this.apiDomain}/api/discount/cash/${id}/clone`;

    const response = await http.post<ApiResponse<CashDiscount>>(
      url,
      data,
      this.store
    );
    return response?.data?.data;
  }

  public async deleteDiscount(id?: string) {
    const url = `${this.apiDomain}/api/discount/cash/${id}`;
    const response = await http.remove<ApiResponse<CashDiscount>>(
      url,
      this.store
    );
    return response?.data?.data;
  }
}
